import { createAsyncThunk } from '@reduxjs/toolkit'
import { SurveyData } from 'redux/slices/onboarding-slice'
import railsApiService from 'services/api/rails-api-service'
import { filterQueryParams } from 'utils/filterQueryParams'

interface GetSurveyParams {
  spe: string
  consultation_id?: number
  email?: string
  order_id?: number
  order_number?: string
  pdid?: string
  show_full_survey?: boolean
}

export const getSurvey = createAsyncThunk(
  'get-survey',
  async (
    { spe, consultation_id, email, order_id, order_number, pdid, show_full_survey }: GetSurveyParams,
    { rejectWithValue }
  ) => {
    try {
      const { data } = await railsApiService.apiInstance.get<SurveyData>('/api/v1/survey', {
        params: filterQueryParams({
          spe,
          consultation_id,
          email,
          order_id,
          order_number,
          pdid,
          show_full_survey
        })
      })

      return data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)
